import RoomStatusIndexVue from "@/views/room-status/RoomStatusIndex.vue";

const roomStatus = [
  {
    path: "/room-status",
    name: "room-status",
    component: RoomStatusIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice"],
      public: false,
    },
  },
];

export default roomStatus;
